import { render } from "./AdminTab.vue?vue&type=template&id=b4ea7dae"
import script from "./AdminTab.vue?vue&type=script&lang=js"
export * from "./AdminTab.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__